import React, { useEffect } from "react";
import { Hero } from "@/components/landing/Hero";
import { TrustBar } from "@/components/landing/TrustBar";
import { Benefits } from "@/components/landing/Benefits";
import { Included } from "@/components/landing/Included";
import { Testimonials } from "@/components/landing/Testimonials";
import { AboutAuthor } from "@/components/landing/AboutAuthor";
import { Offer } from "@/components/landing/Offer";
import { Guarantee } from "@/components/landing/Guarantee";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";
import { StickyCta } from "@/components/landing/StickyCta";

export default function Landing() {
  useEffect(() => {
    document.title =
      "El Arca de Noé – Ebook para colorear (2–6 años) | CreativesMar";
  }, []);

  return (
    <main className="min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--foreground))]">
      <Hero />
      <TrustBar />
      <Benefits />
      <Included />
      <Testimonials />
      <AboutAuthor />
      <Offer />
      <Guarantee />
      <Faq />
      <FinalCta />
      <Footer />
      <StickyCta />
    </main>
  );
}
